export default function () {
	const match =
		RegExp(/\/(locations|mobile)\/([0-9]+)/).exec(window.location.pathname) ||
		[];
	return match[2];
}
